import { useSelector } from 'react-redux'
import { Grid } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import ModifyFileLimitForm from '../components/ModifyFileLimitForm';


const ModifyFileLimitPage = (uuid) => {
    const customization = useSelector((state) => state.customization);

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                    {customization.login && (<ModifyFileLimitForm uuid={uuid}/>)}
            </Grid>
        </Grid>
    );
};

export default ModifyFileLimitPage;